// extracted by mini-css-extract-plugin
export default {"tableHeader":"styles_tableHeader__f2HEG","row":"styles_row__FohPR","section":"styles_section__HFniQ","sectionTitle":"styles_sectionTitle__h5HqW"};